import type { ReactNode } from 'react';

export const symbol_dining: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M361-200.08q7-7.09 7-17.92v-253q29-4 49.5-26.5t20.5-51.82V-703q0-10-7-16.5t-17-6.5q-10 0-16.5 6.5t-6.5 16.13V-583h-22v-120.37q0-9.63-6.5-16.13Q356-726 346-726t-16.5 6.5q-6.5 6.5-6.5 16.13V-583h-29v-120.37q0-9.63-6.5-16.13Q281-726 271-726t-16.5 6.5Q248-713 248-703v153.68q0 29.32 20 51.82t50 26.5v253q0 10.83 7.12 17.92 7.11 7.08 18 7.08 10.88 0 17.88-7.08Zm253 0q7-7.09 7-17.92v-241q35-14 55-49.9 20-35.89 20-84.1 0-57-27.7-95-27.71-38-69.5-38-41.8 0-68.8 38t-27 95q0 51 18 86t50 48v241q0 10.83 7.12 17.92 7.11 7.08 18 7.08 10.88 0 17.88-7.08ZM140-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h680q24 0 42 18t18 42v680q0 24-18 42t-42 18H140Zm0-60h680v-680H140v680Zm0 0v-680 680Z"
		/>
	</svg>
);
